<div *ngIf="item">
	<div class="flex-container-new card" *ngIf="{isLinkExpired: isLinkExpiredObservable | async} as context">
		<div *ngIf="item.functionAppInfo" style="transform: scale(0.65)" class="ribbon ribbon-top-right-beta beta hover-target"><span>Beta</span></div>
		<aside *ngIf="item.functionAppInfo" class="hover-popup">
			<h6>This link executes a custom version.</h6>
			<ng-container *ngIf="item.functionAppInfo.sourceApp">
				Custom source: {{item.functionAppInfo.sourceApp.functionAppName}} <br>
			</ng-container>
			<ng-container *ngIf="item.functionAppInfo.targetApp">
				Custom target: {{item.functionAppInfo.targetApp.functionAppName}} <br>
			</ng-container>
			<ng-container *ngIf="item.functionAppInfo.globalApp">
				Custom global: {{item.functionAppInfo.globalApp.functionAppName}} <br>
			</ng-container>
			<ng-container *ngIf="item.functionAppInfo.entryPointApp">
				Custom entry point: {{item.functionAppInfo.entryPointApp.functionAppName}} <br>
			</ng-container>
		</aside>

		<div *ngIf="context.isLinkExpired" style="transform: scale(0.65)" class="ribbon ribbon-top-right danger">
			<span>EXPIRED</span></div>
		<ng-container *ngIf="!(item.fromAppHeaderImageRef) && !(item.toAppHeaderImageRef)">
			<div class="header">Placeholder</div>
		</ng-container>
		<ng-container *ngIf="item.fromAppHeaderImageRef || item.toAppHeaderImageRef">
			<div class="header" [ngStyle]="{'background-color': setHeaderColor(item)}"><img class="appTile" [src]="getUrl(getProperImageRef(item))" /></div>
		</ng-container>

		<div class="header-padding-apptiles" style="max-height:40px"></div>
		<div class="applicationlink-icon" style="max-height:80px"><img style="width: 50px; height: 50px;" [src]="getUrl('/application-logos/applicationlink-custom-arrow.png')"></div>
		<div class="integrationtitle-flexbox">
			<!-- <div class="integrationtitle">{{item.toDName}}</div> -->
			<ng-container *ngIf="item.fromAppHeaderImageRef || item.toAppHeaderImageRef">
				<div class="integrationtitle">{{getIntegrationTitleName(item)}}</div>
			</ng-container>
			<ng-container *ngIf="!(item.fromAppHeaderImageRef) && !(item.toAppHeaderImageRef)">
				<div class="header">Placeholder</div>
			</ng-container>
			<div class="integrationsubtitle">{{item.linkName}}</div>

		</div>
		<div class="applicationlink-divider">
			<div *ngIf="!item.frontendPage">
				<div *ngIf="currentStatusColorSubject.asObservable() | async as itemStatus">
					<div [ngClass]="{'alert-success': itemStatus===linkStatusCode.Success, 'alert-info': itemStatus===linkStatusCode.Info, 'alert-danger': itemStatus===linkStatusCode.Danger}" class="alert">{{ currentStatusSubject.asObservable() | async }}</div>
				</div>
			</div>
			<hr style="margin-top: 0.25rem; margin-bottom: 0.5rem;">
		</div>
		<div class="applicationlink-buttons" style="max-height:60px">
			<div class="button-container">
				<div style="cursor: pointer" class="document-icon far fa-file-alt fa-3x fa-fw clickable" (click)="navigateToInfo($event)" title="Status"></div>
				<div style="cursor: pointer;position: relative; top: 1px;" class="chart-icon far fa-cog fa-3x fa-fw" (click)="navigateToSetup($event)" title="Setup"></div>
				<ng-container *ngIf="!item.frontendPage">
					<div style="cursor: pointer" class="agenda-icon clickable-icon far fa-calendar-alt fa-3x scheduler fa-fw" (click)="navigateToScheduler($event)" title="Scheduler"></div>
				</ng-container>

				<ng-container *ngIf="item.frontendPage != null && item.frontendPage.length > 0">
					<div *ngIf="context.isLinkExpired" style="transform-origin: top" class="document-icon far fa-play fa-3x fa-fw clickable play-disabled" title="Link expired"></div>
					<div *ngIf="!context.isLinkExpired" style="transform-origin: top; cursor: pointer" class="document-icon far fa-play fa-3x fa-fw clickable" title="Open platform" (click)="pressPlay()"></div>

				</ng-container>
				<ng-container *ngIf="item.frontendPage != null && item.frontendPage.length == 0">
					<ng-container *ngIf="disabledRunLinkButtonObservable | async as linkStatus">
						<span *ngIf="linkStatus == linkRunStatus.inactive" style="transform-origin: top; position: relative; top: -6px;" class="arrow" title="Execute link" (click)="pressPlay()"><i
								class="document-icon far fa-play fa-3x arrowicon clickable fa-fw"></i></span>
						<span *ngIf="linkStatus == linkRunStatus.undefined" style="opacity: 0.3; pointer-events: none; transform-origin: top; position: relative; top: -6px;" title="Loading link.." class="arrow"><i class="far fa-play fa-3x arrowicon fa-fw"></i></span>
						<span *ngIf="linkStatus == linkRunStatus.active" title="Processing" class="processing" style="transform-origin: top" (click)="$event.stopPropagation();">
							<div style="
					transform: scale(0.15);
					transform-origin: top left;
					position: absolute;
					top: -40px;
					left: -37px;
				">
								<svg class="machine" x="0px" y="0px" viewBox="0 0 645 526" style="
					width: 800px;
					height: 800px">
									<defs />
									<g>
										<path x="-173,694" y="-173,694" class="large"
											d="M635 184v-21l-29-4c-1-10-3-19-6-28l25-14 -8-19 -28 7c-5-8-10-16-16-24L592 58l-15-15 -23 17c-7-6-15-11-24-16l7-28 -19-8 -14 25c-9-3-18-5-28-6L472 0h-21l-4 29c-10 1-19 3-28 6L405 9l-19 8 7 28c-8 5-16 10-24 16l-23-17L331 58l17 23c-6 7-11 15-16 24l-28-7 -8 19 25 14c-3 9-5 18-6 28l-29 4v21l29 4c1 10 3 19 6 28l-25 14 8 19 28-7c5 8 10 16 16 24l-17 23 15 15 23-17c7 6 15 11 24 16l-7 28 19 8 14-25c9 3 18 5 28 6l4 29h21l4-29c10-1 19-3 28-6l14 25 19-8 -7-28c8-5 16-10 24-16l23 17 15-15 -17-23c6-7 11-15 16-24l28 7 8-19 -25-14c3-9 5-18 6-28L635 184zM461 284c-61 0-110-49-110-110S401 64 461 64s110 49 110 110S522 284 461 284z" />
									</g>
									<g>
										<path x="-136,996" y="-136,996" class="medium"
											d="M392 390v-21l-28-4c-1-10-4-19-7-28l23-17 -11-18L342 313c-6-8-13-14-20-20l11-26 -18-11 -17 23c-9-4-18-6-28-7l-4-28h-21l-4 28c-10 1-19 4-28 7l-17-23 -18 11 11 26c-8 6-14 13-20 20l-26-11 -11 18 23 17c-4 9-6 18-7 28l-28 4v21l28 4c1 10 4 19 7 28l-23 17 11 18 26-11c6 8 13 14 20 20l-11 26 18 11 17-23c9 4 18 6 28 7l4 28h21l4-28c10-1 19-4 28-7l17 23 18-11 -11-26c8-6 14-13 20-20l26 11 11-18 -23-17c4-9 6-18 7-28L392 390zM255 453c-41 0-74-33-74-74 0-41 33-74 74-74 41 0 74 33 74 74C328 420 295 453 255 453z" />
									</g>
								</svg>
							</div>
						</span>
					</ng-container>
				</ng-container>



				<!-- <span style="transform-origin: top" class="arrow" title="Execute link">
					<div class="playbutton-icon far fa-play fa-3x arrowicon clickable fa-fw"></div>
				</span> -->
			</div>
		</div>
	</div>
</div>
